import { Component, OnInit, Input, HostListener, ElementRef, Output, EventEmitter } from '@angular/core';
import { Content } from "../../models/content";
import { Player } from "../../models/player";
@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {

  isSubmitted = false;
  @Output()
  summaryCanvasScale: EventEmitter<number> = new EventEmitter();
  canvasScale = 1;
  @Input()
  content: Content;
  @Input()
  players: Player[];
  @Input()
  primaryColor: string;
  @Input()
  secondaryColor: string;

  constructor() { }

  ngOnInit() {
    this.onWindowResize();
  }

  getPlayerName(id: number){
    var player = this.players.find(pl => pl.getPlayerID() == id);
    if(player) return player.getName();
    return null;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize(e?: any) {
    const avail = { // canvas margin-y = 50px
      "width": window.innerWidth*.5 - 100, // img container = 50% vw (col-6). ( - arbitrary fixed margin-x = 50px per side)
      "height": window.innerHeight - 200 // 100vh - (menuMargins - headerHeight - footerHeight), from variables.scss
    }
    this.canvasScale = 1;
    if (this.content.width * this.canvasScale > avail.width) this.canvasScale = avail.width/this.content.width;
    if (this.content.height * this.canvasScale > avail.height) this.canvasScale = avail.height/this.content.height;
    this.summaryCanvasScale.emit(this.canvasScale);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/summary/summary.component.ts